import {
  axiosInstance,
  getErrorStatus
} from './axiosInstance';

export const listDocuments = async () => {

  let response;
  const businessId = sessionStorage.getItem('businessId');
  try {

    response = await axiosInstance.get(`/business-documents/${businessId}/documents`);

  } catch (err) {

    response = {
      data: {
        traceId: err?.response?.headers?.['x-amzn-trace-id'] || '',
        error: {
          ...(err || {}),
          status: getErrorStatus(err)
        }
      }
    };
  }

  return response.data;
};

export const fetchDocument = async (docId) => {

  let response;
  const businessId = sessionStorage.getItem('businessId');
  try {

    response = await axiosInstance.get(`/business-documents/${businessId}/documents/${docId}`);

  } catch (err) {

    response = {
      data: {
        docId,
        traceId: err?.response?.headers?.['x-amzn-trace-id'] || '',
        error: {
          ...(err || {}),
          status: getErrorStatus(err)
        }
      }
    };
  }

  return response.data;
};

export const uploadDocument = async (file, docType, docName) => {

  let response;
  const businessId = sessionStorage.getItem('businessId');
  const body = new FormData();
  body.append(docName, file, docName);

  try {

    response = await axiosInstance.post(`/business-documents/${businessId}/document`, body, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      params: {
        docType: 'pdf',
        docName
      }
    });

  } catch (err) {

    response = {
      data: {
        file,
        docType,
        docName,
        traceId: err?.response?.headers?.['x-amzn-trace-id'] || '',
        error: {
          ...(err || {}),
          status: getErrorStatus(err)
        }
      }
    };
  }

  return response.data;
};

export const deleteDocument = async (docId) => {

  let response;
  const businessId = sessionStorage.getItem('businessId');
  try {
    response = await axiosInstance.delete(`/business-documents/${businessId}/documents/${docId}`);

  } catch (err) {

    response = {
      data: {
        docId,
        traceId: err?.response?.headers?.['x-amzn-trace-id'] || '',
        error: {
          ...(err || {}),
          status: getErrorStatus(err)
        }
      }
    };
  }

  return response.data;
};